<template>
    <div
        :class="{'related-items': true, 'related-items--no-spacing': !topSpacing}"
        v-if="list"
    >
        <slot></slot>
        <List>
            <Item v-for="(item, index) in list" :key="post_id + '-' +item.id + '-' + index" :item="item" />
        </List>
    </div>
</template>

<script>
// import GetDateTime from '@/utils/GetDateTime';
import Link from '@/components/ui/Link.vue';
import List from '@/components/ui/List.vue';
import Item from '@/components/Item.vue';

export default {
    name: 'related-items',

    props: {
        list: {
            type: Array,
            default: [],
        },
        post_id: {
            type: Number,
            default: 0,
        },
        topSpacing: {
            type: Boolean,
            default: true
        }
    },

    // methods: {
    //     GetDateTime: GetDateTime,
    // },

    components: {
        Link,
        List,
        Item,
    },
    // mounted() {
    //     console.log(this.list)

    // },
}

</script>

<style lang="scss">
    .related-title {
        padding: 0 var(--padding) var(--padding-25);
        font-size: var(--large-size);

        a {
            text-decoration: underline;
            &:hover {
                text-decoration: none;
            }
        }
    }

    .related-items {
        margin: var(--padding-x3) 0;
        width: 100%;

        &.related-items--no-spacing {
            margin: 0;
        }
    }

    @media only screen and (max-width: 767px) {
        .related-title {
            text-align: center;
            font-size: var(--large-size);

        }
    }
</style>
